import FilterRowViewModel from './FilterRowViewModel';
import MultiSelectFilterRow from 'main/stores/reports/MultiSelectFilterRow';
import _ from 'lodash';
import { observable, action, computed, makeObservable } from 'mobx';

class MultiSelectFilterRowViewModel extends FilterRowViewModel {
  mapItem;
  dataSource;
  translatable;

  options = [];
  loading = false;
  loaded = false;
  operatorOpen = false;
  optionsOpen = false;
  searchable = false;
  searchFilter = '';

  constructor({define, dataSource, mapItem, translatable, searchable}) {
    super(define);

    makeObservable(this, {
      options: observable,
      loading: observable,
      loaded: observable,
      operatorOpen: observable,
      optionsOpen: observable,
      searchable: observable,
      searchFilter: observable,
      load: action,
      initWithExistingData: action,
      closeDropdowns: action,
      openOperator: action,
      closeOperator: action,
      openOptions: action,
      closeOptions: action,
      applySearchFilter: action,
      editValues: action,
      filteredOptions: computed,
      selectedValues: computed
    });

    this.dataSource = dataSource;
    this.mapItem = mapItem || (item => item);
    this.translatable = translatable;
    this.searchable = searchable;
    this.row.values = [];
    this.editingRow.values = [];
  }

  createRow(row) {
    return new MultiSelectFilterRow(row);
  }

  async load() {
    this.loading = true;
    const data = await this.dataSource.load();
    this.options = data.map(this.mapItem);
    this.loading = false;
    this.loaded = true;
  }

  initWithExistingData({data}) {
    this.options = data.map(this.mapItem);
    this.loading = false;
    this.loaded = true;
  }

  closeDropdowns() {
    this.closeOperator();
    this.closeOptions();
  }

  openOperator() {
    this.closeOptions();
    this.operatorOpen = true;
  }

  closeOperator() {
    this.operatorOpen = false;
    this.resetRow();
  }

  async openOptions() {
    this.closeOperator();
    this.optionsOpen = true;
    if (this.loading) return;

    if (!this.loaded) {
      await this.load();
    }
  }

  closeOptions() {
    this.optionsOpen = false;
    this.resetRow();
  }

  applySearchFilter(value) {
    this.searchFilter = value;
  }

  editValues(value, checked) {
    if (checked) {
      this.editingRow.add(value.id);
    } else {
      this.editingRow.remove(value.id);
    }
  }

  get filteredOptions() {
    if (!this.searchable) return this.options;

    const filter = _.lowerCase(this.searchFilter);
    return _.reject(this.options, c => _.lowerCase(c.name).indexOf(filter) === -1);
  }

  get selectedValues() {
    return _.map(_.sortBy(this.editingRow.values), (id) => {
      return _.find(this.options, {id}).name;
    });
  }
}

export default MultiSelectFilterRowViewModel;
